import { Component, OnInit, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
//import * as AOS from 'aos';
import { LinkService } from '../../_services/langhfre.service';

//declare function ire(string,{}): any;

@Component({
  selector: 'app-academic-phrasebank',
  templateUrl: './academic-phrasebank.component.html',
  styleUrls: ['./academic-phrasebank.component.scss']
})
export class AcademicPhrasebankComponent implements OnInit {
  phaseBankSearchForm: FormGroup;
  email: any;
  // emailEnterprise : FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private LinkService: LinkService
  ) {
    this.phaseBankSearchForm = this.fb.group({
      'sentence': ['', Validators.required]
    });
  }

  ngOnInit() {
    this.titleService.setTitle("Trinka 免費學術語句庫");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka 的免費學術語句庫是一項實用資源，收錄了學術與科學寫作中常見的關鍵語句，特別適合學術寫作者、大學生與研究人員使用。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinka 免費學術語句庫" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka 的免費學術語句庫是一項實用資源，收錄了學術與科學寫作中常見的關鍵語句，特別適合學術寫作者、大學生與研究人員使用。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/academic-phrasebank' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/academic-phrasebank' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/tw/academic-phrasebank' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/academic-phrasebank' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/academic-phrasebank' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/academic-phrasebank' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/academic-phrasebank' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/academic-phrasebank' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/academic-phrasebank' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/academic-phrasebank' });

  }

  sectionValue(section: string) {
    this.formSection = true;
    this.thankSection = false;
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  phaseBankSearch() {
    if (this.phaseBankSearchForm.valid) {
      const data: NavigationExtras = {
        state: {
          sentence: Object.values(this.phaseBankSearchForm.value)
        }
      };
      this.router.navigate(['academic-phrasebank-browse', 'topic', 'subtopic'], data);
    } else {
      this.toastr.warning("Search field can not be empty");
    }
  }
  stopAllVideos() {
    const iframes = Array.from(document.querySelectorAll('iframe.youtubeVideoForTryDemo'));
    iframes.forEach((iframe) => {
        const htmlIframe = iframe as HTMLIFrameElement;
        htmlIframe.src = htmlIframe.src;
    });
  }

  scrollToActiveTab() {
    const currentUrl = this.router.url;
    let activeElement: HTMLElement | null = null;

    if (currentUrl.includes('academic-phrasebank')) {
      activeElement = document.querySelector('#tab-phrasebank');
    } else if (currentUrl.includes('ai-content-detector')) {
      activeElement = document.querySelector('#tab-ai-detector');
    } else if (currentUrl.includes('paraphrasing-tool')) {
      activeElement = document.querySelector('#tab-paraphraser');
    } else if (currentUrl.includes('grammar-checker')) {
      activeElement = document.querySelector('#tab-grammar');
    }

    // Ensure the active tab is scrolled into view
    if (activeElement) {
      activeElement.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    }
  }
}
